<template>
  <div>
    <headerView/>
    <div class="otc-main">
      <div class="otc-container">
        <!--请选择购买渠道-->
        <h1 class="bold">{{$t('100983')}}</h1>
        <div class="tabs flex-between">
          <div class="inline-block pointer relative tab-item" :class="{active: activeTab == 'banxa'}" @click="activeTab = 'banxa'">
            <img :src="channelObj.banxa.logo" alt="Simplex">
            <span class="inline-block">&nbsp;&nbsp;{{channelObj.banxa.title}}</span>
            <svg slot="image" class="icon absolute" :class="isDirection ? 'left' : 'right'" aria-hidden="true" v-show="activeTab == 'banxa'">
              <use :xlink:href="isDirection ? '#icon-gouxuan-fan' : '#icon-gouxuan'"></use>
            </svg>
          </div>
          <div class="inline-block pointer relative tab-item" :class="{active: activeTab == 'simplex'}" @click="activeTab = 'simplex'">
            <img :src="channelObj.simplex.logo" alt="Banxa">
            <span class="inline-block">&nbsp;&nbsp;{{channelObj.simplex.title}}</span>
            <svg slot="image" class="icon absolute" :class="isDirection ? 'left' : 'right'" aria-hidden="true" v-show="activeTab == 'simplex'">
              <use :xlink:href="isDirection ? '#icon-gouxuan-fan' : '#icon-gouxuan'"></use>
            </svg>
          </div>
        </div>
        <div class="statement-content">
          <!--声明-->
          <p class="bold">{{$t('100984')}}</p>
          <!--您将离开 SuperEX 跳转到 www.simplex.com；该购买服务由第三方机构 Simplex 提供，购买前请仔细阅读 Simplex使用协议；购买过程中，若您有任何问题，可以联系 Simplex 客服 support@simplex.com。-->
          <span class="block" v-show="activeTab == 'simplex'">{{$t('100985')}}</span>
          <!--您将离开 SuperEX 跳转到 https://banxa.com/；该购买服务由第三方机构 Banxa 提供，购买前请仔细阅读 Banxa使用协议；购买过程中，若您有任何问题，可以联系 Banxa 客服 support.banxa.com。-->
          <span class="block" v-show="activeTab == 'banxa'">{{$t('100986')}}</span>
          <!--我已阅读并同意免责声明-->
          <el-checkbox v-model="checked">{{$t('100987')}}</el-checkbox>
          <!--立即下单-->
          <el-button class="form-btn" :disabled="!checked || !activeTab" @click="handleClick">{{$t('100988')}}</el-button>
        </div>
        <div class="tutorial">
          <!--交易教程-->
          <p class="bold">{{$t('100989')}}</p>
          <div class="step step_1">
            <span class="block">1. {{activeTab == 'banxa' ? $t('100990') : $t('100991')}}</span>
            <img :src="channelObj[activeTab].img1" alt="" />
          </div>
          <div class="step step_2">
            <span class="block">2. {{activeTab == 'banxa' ? $t('100991') : $t('100990')}}</span>
            <img :src="channelObj[activeTab].img2" alt="" />
          </div>
          <div class="step step_3">
            <span class="block">3. {{activeTab == 'banxa' ? $t('100992') : $t('101004')}}</span>
            <img :src="channelObj[activeTab].img3" alt="" />
          </div>
        </div>
      </div>
    </div>
    <!-- <footerView/> -->
    <SiteMap/>
  </div>
</template>

<script>
import headerView from "@/components/headerView";
import footerView from "@/components/footerView";
import SiteMap from '@/components/NewHome/SiteMap'
import urls from "@/utils/baseUrl";
import {mapGetters} from 'vuex'

export default {
  name: "buyCoin",
  components: {
    headerView, footerView,SiteMap
  },
  computed: {
    ...mapGetters(['styleType','isDirection'])
  },
  data() {
    return {
      activeTab: 'banxa',
      channelObj: {
        simplex: {
          logo: `${urls.staticState}/static/images/buyCoin/Simplex_logo.png`,
          title: 'Simplex',
          img1: `${urls.staticState}/static/images/buyCoin/simplex_1.png`,
          img2: `${urls.staticState}/static/images/buyCoin/simplex_2.png`,
          img3: `${urls.staticState}/static/images/buyCoin/simplex_3.png`
        },
        banxa: {
          logo: `${urls.staticState}/static/images/buyCoin/banxa_logo.png`,
          title: 'Banxa',
          img1: `${urls.staticState}/static/images/buyCoin/banxa_1.png`,
          img2: `${urls.staticState}/static/images/buyCoin/banxa_2.png`,
          img3: `${urls.staticState}/static/images/buyCoin/banxa_3.png`
        }
      },
      staticState: urls.staticState,
      checked: false
    }
  },
  created() {
    window.document.documentElement.setAttribute("dir", this.isDirection ? 'rtl' : 'ltr');
    window.document.documentElement.setAttribute("data-theme", this.styleType);
  },
  methods: {
    handleClick() {
      const {href} = this.$router.resolve({
        path: '/jump',
        query: {
          link: this.activeTab == 'simplex' ? 'https://buy.chainbits.com' : 'https://checkout.banxa.com',
        }
      })
      window.open(href, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/variable";
@import "../../../assets/css/mixin";

.otc-main {
  width: 100%;
  height: auto;
  min-height: calc(100vh - #{400px});
  .otc-container{
    padding-top: 48px;
    max-width: 700px;
    margin: 0 auto;
    h1.bold{
      margin: 0;
      font-size: $font-size-Bigger;
      @include font_color('font-color');
    }
    .tabs{
      padding: 40px 0;
      border-bottom: 1px solid;
      @include border_color('border-color-normal');
      .tab-item{
        width: 49%;
        border-radius: 6px;
        padding: 10px 24px;
        border: 1px solid;
        @include border_color('border-color-normal');
        @include background_color('button-bg-normal');
        img{
          max-width: 32px;
          max-height: 32px;
        }
        span{
          font-size: $font-size-normal;
          @include font_color('font-color');
          vertical-align: 8px;
        }
        svg.left{
          left: 0;
        }
        svg.right{
          right: 0;
        }
        svg{
          width: 16px;
          height: 16px;
          bottom: 0;
        }
      }
      .tab-item.active{
        border-color: $border-color-active;
      }
    }
    .statement-content{
      padding: 48px 0;
      border-bottom: 1px solid;
      @include border_color('border-color-normal');
      p{
        font-size: 24px;
        @include font_color('font-color');
      }
      span.block{
        font-size: $font-size-small;
        @include font_color('font-color-1');
        line-height: 1.5;
        margin: 16px 0;
      }
      ::v-deep .el-checkbox__label{
        @include font_color('font-color');
        padding: 0 10px;
      }
      ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
      ::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
        background-color: $button-bg;
        border-color: $border-color-active;
      }
      ::v-deep .el-checkbox__inner::after{
        border-color: $font-color-3;
      }
      ::v-deep .el-checkbox__inner:hover,
      ::v-deep .el-checkbox__inner:focus,
      ::v-deep .el-checkbox__input.is-focus .el-checkbox__inner{
        border-color: $border-color-active;
      }
      ::v-deep .el-checkbox__inner{
        background: transparent;
        @include border_color('font-color');
      }
      .form-btn{
        margin-top: 24px;
        padding: 10px 0;
        font-weight: 600;
        font-family: Lato-Semibold;
      }
      ::v-deep .el-button.is-disabled,
      .el-button.is-disabled:focus,
      .el-button.is-disabled:hover{
        @include font_color('font-color-1');
        @include background_color('button-bg-disabled');
      }
    }
    .tutorial{
      padding: 48px 0 72px;
      p.bold{
        font-size: 24px;
        @include font_color('font-color');
      }
      .step{
        span.block{
          font-size: $font-size-small;
          line-height: 1.5;
          @include font_color('font-color');
          margin:32px 0 16px;
        }
        img{
          max-width: 700px;
        }
      }
    }
  }
}
</style>
